var extensionPS = `
`;

export { extensionPS as default };
